// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ImportedPricingCompany {
  readonly id: string;
  readonly name: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
  }

  static zero(): ImportedPricingCompany {
    const zeroValues: ExcludeMethodsDeep<ImportedPricingCompany> = {
      id: NIL_UUID,
      name: '',
    };
    return new ImportedPricingCompany(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ImportedPricingCompanyWireFormat = {
  id: string;
  name: string;
};

type NewImportedPricingCompanyProps = PartialDeep<
  ImportedPricingCompany,
  { recurseIntoArrays: true }
>;
export const NewImportedPricingCompany: (
  props: NewImportedPricingCompanyProps,
) => ImportedPricingCompany = (props) => new ImportedPricingCompany(props);

type NewImportedPricingCompanyFromWireFormatProps = PartialDeep<
  ImportedPricingCompanyWireFormat,
  { recurseIntoArrays: true }
>;
export const NewImportedPricingCompanyFromWireFormat: (
  props: NewImportedPricingCompanyFromWireFormatProps,
) => ImportedPricingCompany = (props) => new ImportedPricingCompany(props);
